"use strict";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import assert from "@charlesderek/assert";
import { store } from "../store";
import { track_event, get_number_of_visits_in_the_last_24_hours } from "../views/common/tracker";
import { get_browser_name } from "../utils/get_browser_info";
import { disable_ezoic, enable_ezoic } from "./ezoic";
import { getElementScrollPos, addScrollListener } from "../pretty_scroll_area";
import { loadScript } from "../loadScript";
import { isAdsense, isGpt, getGptSlots, getAdsenseSlots, isEzoic } from "./slots";
export { loadAds };
export { user_donated };
export var AD_REMOVAL_KEY = "ad_removal";
export { loadAds };
var SHOW_DELAY = 1.3;
initAds();

function initAds() {
  if (is_nodejs()) {
    return;
  }

  thanks_page_redirection();
  var donated = user_donated();

  if (donated) {
    document.documentElement.classList.add("user-donated");
  }

  if (donated) {
    disable_ezoic();
  } else {
    enable_ezoic();
  }
}

function loadAds(_x) {
  return _loadAds.apply(this, arguments);
}

function _loadAds() {
  _loadAds = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(adSlots) {
    var noAds, success;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (dont_show_ads(adSlots)) {
              noAds = true;
            }

            if (noAds) {
              _context.next = 19;
              break;
            }

            if (!isEzoic(adSlots)) {
              _context.next = 8;
              break;
            }

            _context.next = 5;
            return loadAdsenseCode();

          case 5:
            success = _context.sent;
            _context.next = 18;
            break;

          case 8:
            if (!isAdsense(adSlots)) {
              _context.next = 14;
              break;
            }

            _context.next = 11;
            return loadAdsense(adSlots);

          case 11:
            success = _context.sent;
            _context.next = 18;
            break;

          case 14:
            if (!isGpt(adSlots)) {
              _context.next = 18;
              break;
            }

            _context.next = 17;
            return loadGpt(adSlots);

          case 17:
            success = _context.sent;

          case 18:
            if (!success) noAds = true;

          case 19:
            if (noAds) {
              document.documentElement.classList.add("no-ads");
            } else {
              setTimeout(function () {
                document.documentElement.classList.add("show-ads");
                enable_floating_ads();
              }, SHOW_DELAY * 1000);
            }

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _loadAds.apply(this, arguments);
}

function disableAds() {
  store.set_val(AD_REMOVAL_KEY, true);
  disable_ezoic();
}

function loadGpt(_x2) {
  return _loadGpt.apply(this, arguments);
}

function _loadGpt() {
  _loadGpt = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(adSlots) {
    var gptSlots, success;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            gptSlots = getGptSlots(adSlots);
            assert(gptSlots.length > 0);
            _context2.next = 4;
            return loadScript("https://securepubads.g.doubleclick.net/tag/js/gpt.js", "gpt");

          case 4:
            success = _context2.sent;

            if (success) {
              window.googletag = window.googletag || {
                cmd: []
              };
              window.googletag.cmd.push(function () {
                gptSlots.forEach(function (_ref) {
                  var slot_id = _ref.slot_id,
                      adName = _ref.adName,
                      slotSize = _ref.slotSize;
                  assert(slot_id.constructor === String);
                  assert(adName.constructor === String);
                  assert(slotSize.length === 2 && slotSize[0].constructor === Number && slotSize[1].constructor === Number);
                  window.googletag.defineSlot(adName, slotSize, slot_id).addService(window.googletag.pubads());
                });
                window.googletag.pubads().enableSingleRequest();
                window.googletag.enableServices();
                gptSlots.forEach(function (_ref2) {
                  var slot_id = _ref2.slot_id;
                  window.googletag.cmd.push(function () {
                    window.googletag.display(slot_id);
                  });
                });
              });
            }

            return _context2.abrupt("return", success);

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _loadGpt.apply(this, arguments);
}

function loadAdsense(_x3) {
  return _loadAdsense.apply(this, arguments);
}

function _loadAdsense() {
  _loadAdsense = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(adSlots) {
    var adsenseSlots, success;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            adsenseSlots = getAdsenseSlots(adSlots);
            assert(adsenseSlots.length > 0);
            _context3.next = 4;
            return loadAdsenseCode();

          case 4:
            success = _context3.sent;

            if (success) {
              window.adsbygoogle = window.adsbygoogle || [];
              adsenseSlots.forEach(function () {
                window.adsbygoogle.push({});
              });
            }

            return _context3.abrupt("return", success);

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _loadAdsense.apply(this, arguments);
}

function loadAdsenseCode() {
  return _loadAdsenseCode.apply(this, arguments);
} // Since Clock/Timexecute's source code is open anyone can read this and bypass doing a donation to remove ads.
// If you are short on money then you are more than welcome to do this :-).


function _loadAdsenseCode() {
  _loadAdsenseCode = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
    var success;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return loadScript("https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js", "adsense");

          case 2:
            success = _context4.sent;
            return _context4.abrupt("return", success);

          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _loadAdsenseCode.apply(this, arguments);
}

var _user_donated;

function user_donated() {
  assert(!is_nodejs());

  if (_user_donated !== undefined) {
    assert([true, false].includes(_user_donated));
    return _user_donated;
  }

  _user_donated = check_donation();
  assert([true, false].includes(_user_donated));
  return _user_donated;

  function check_donation() {
    return store.has_val(AD_REMOVAL_KEY);
  }
}

function thanks_page_redirection() {
  if (window.location.hash === "#thanks-for-your-donation") {
    window.location.href = window.location.origin + "/thanks";
  }
}

function dont_show_ads(adSlots) {
  var disableReason = user_donated() && "user_has_donated" || is_small_screen() && "screen_too_small" || ad_blocker_detected() && "ad_blocker_detected";

  if (!disableReason && !isEzoic(adSlots)) {
    disableReason = is_fringe_browser() && "fringe_browser" || is_too_many_visits() && "too_many_visits";
  }

  if (disableReason) {
    trackDisableReason(disableReason);
  }

  return !!disableReason;
}

function trackDisableReason(disableReason) {
  var value;

  if (disableReason === "fringe_browser") {
    value = get_browser_name();
  }

  if (disableReason === "screen_too_small") {
    value = JSON.stringify(get_screen_size());
  }

  track_event({
    name: "[adsense] disabled: " + disableReason,
    value: value
  });
}

function is_too_many_visits() {
  if (get_number_of_visits_in_the_last_24_hours() >= 8) {
    return true;
  }

  return false;
}

function is_small_screen() {
  var _get_screen_size = get_screen_size(),
      width = _get_screen_size.width; // Same as CSS media query


  return width <= 700;
}

function get_screen_size() {
  var _window$screen = window.screen,
      width = _window$screen.width,
      height = _window$screen.height;
  assert(Number.isInteger(width) && width > 0 && Number.isInteger(height) && height > 0, {
    width: width,
    height: height
  });
  return {
    width: width,
    height: height
  };
}

function is_fringe_browser() {
  var browser_name = get_browser_name();
  return !["chrome", "chromium", "safari", "firefox", "internet explorer", "opera", "edge", "microsoft edge"].includes(browser_name.toLowerCase());
}

var _ad_blocker_is_installed;

function ad_blocker_detected() {
  assert(!is_nodejs());

  if (_ad_blocker_is_installed !== undefined) {
    return _ad_blocker_is_installed;
  }

  var ad_blocker_test = document.createElement("div"); // hide

  ad_blocker_test.style.position = "absolute";
  ad_blocker_test.style.visibility = "hidden";
  ad_blocker_test.style.pointerEvents = "none";
  ad_blocker_test.innerHTML = "some_text"; // Ad blockers hide elements with that class

  ad_blocker_test.className = "adsbygoogle";
  document.body.appendChild(ad_blocker_test);
  _ad_blocker_is_installed = ad_blocker_test.offsetHeight === 0;
  document.body.removeChild(ad_blocker_test);
  return _ad_blocker_is_installed;
}

function is_nodejs() {
  return typeof window === "undefined";
}

function enable_floating_ads() {
  Array.from(document.querySelectorAll(".is_floating")).forEach(function (el) {
    var positionOriginal = el.style.position;
    var topOriginal = el.style.top;
    var leftOriginal = el.style.left;
    var oldPosition = positionOriginal;
    var positionTopOriginal;
    var isFixedLayout = false;
    addScrollListener(function (scrollPos) {
      assert(scrollPos >= 0);

      var _getElementScrollPos = getElementScrollPos(el),
          positionLeft = _getElementScrollPos.positionLeft,
          positionTop = _getElementScrollPos.positionTop;

      if (isFixedLayout) {
        assert(positionTopOriginal >= 0);
        isFixedLayout = scrollPos > positionTopOriginal;
      } else {
        isFixedLayout = scrollPos > positionTop;
        positionTopOriginal = positionTop;
      }

      var newPosition = isFixedLayout ? "fixed" : positionOriginal;

      if (newPosition !== oldPosition) {
        if (newPosition === "fixed") {
          el.style.position = newPosition;
          el.style.top = "0px";
          el.style.left = positionLeft + "px";
        } else {
          el.style.position = positionOriginal;
          el.style.top = topOriginal;
          el.style.left = leftOriginal;
        }

        oldPosition = newPosition;
      }
    }, {
      fireInitialScroll: true,
      onlyUserScroll: false
    });
  });
}